import { personaTypes } from '../../types'
import { ReduxAction, reduxTypes } from '../types'

function update(persona: personaTypes.Persona): ReduxAction<personaTypes.Persona> {
  return {
    payload: persona,
    type: reduxTypes.PERSONA_UPDATE,
  }
}

export default {
  update,
}
